import React from 'react';
import { Moon, Sun } from 'lucide-react';
interface DarkModeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}
export function DarkModeToggle({
  isDark,
  onToggle
}: DarkModeToggleProps) {
  return <button onClick={onToggle} className={`
        p-2 rounded-full transition-all duration-300
        ${isDark ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}
      `} aria-label="Toggle dark mode" data-id="element-97">
      {isDark ? <Sun className="w-5 h-5" data-id="element-98" /> : <Moon className="w-5 h-5" data-id="element-99" />}
    </button>;
}